import { UserPreferencePreferredDevice } from "xchelper/models/userPreference.model";

export default class UserController {
  constructor(
    $scope,
    XucUser,
    $translate,
    CtiProxy,
    $state,
    forward,
    BrowserService,
    UserPreferenceService,
    $rootScope,
    WebHIDHeadsetService,
    ExternalEvent,
    remoteConfiguration,
    errorModal
  ) {
    let errorDisplayed = false;
    $scope.user = {};
    $scope.connectedHIDDevice = WebHIDHeadsetService.getCurrentDeviceName();
    $rootScope.$on(ExternalEvent.WEBHID_DEVICE_SELECTED, (_, device) => {
      console.debug(`Received ${device} in UserController`);
      $scope.connectedHIDDevice = device;
      if (!$rootScope.$$phase) $scope.$apply();
    });

    var switchHandler = $rootScope.$on(CtiProxy.ASK_PHONE_SWITCH, () => {
      if (!CtiProxy.isUsingUa()) {
        return;
      }

      askSwitchFromUser(
        getFallBackErrorMessage(),
        getSwitchConfirmationMessage()
      ).then((shoudlFallback) => {
        if (shoudlFallback) {
          console.log("Falling back to phone");
          uaFallBackToPhone();
        }
      });

    });

    $rootScope.$on(UserPreferenceService.USER_PREFERENCES_UPDATE, () => {
      if(!$scope.$$phase) $scope.$apply();
    });


    const askSwitchFromUser = (errorMsg, confirmationMsg) =>  {
      if (errorDisplayed) {
        return Promise.resolve(false);
      }
      errorDisplayed = true;
      const modal = errorModal.showErrorModal(errorMsg, true, true, confirmationMsg);
      if (modal) {
        return new Promise((resolve) => {
          modal.result.then((result) => {
            errorDisplayed = false;
            resolve(!result);
          }, () => {
            errorDisplayed = false;
            resolve(true);
          });
        });
      }
      errorDisplayed = false;
      return Promise.resolve(false);
    };


    const getFallBackErrorMessage = () => {
      return (
        "UA_FALLBACK_ERROR_MSG_" +
        UserPreferenceService.getPreferredDevice(true).toUpperCase()
      );
    };

    const getSwitchConfirmationMessage = () => {
      return (
        "UA_FALLBACK_SWITCH_CONFIRMATION_MSG_" +
        UserPreferenceService.getPreferredDevice(true).toUpperCase()
      );
    };

    const uaFallBackToPhone = () => {
      const { isUsingMobileApp, isUsingUa } = CtiProxy;
      const currentPreferrenceModel = Object.assign(
        {},
        UserPreferenceService.getPrefferedDeviceModel(
          isUsingMobileApp,
          isUsingUa
        )
      );
      currentPreferrenceModel.webrtc = false;
      currentPreferrenceModel.mobile = false;
      currentPreferrenceModel.phone = true;

      CtiProxy.toggleUniqueAccountDevice(
        UserPreferenceService.getPreferredDeviceFromModel(currentPreferrenceModel)
      );
    };

    if (BrowserService.browser === "firefox" && CtiProxy.isUsingWebRtc()) {
      BrowserService.compatibilityAlert();
    }

    remoteConfiguration
      .getBoolean("showInternalNumber", false)
      .then((value) => {
        $scope.displayNumber = value;
      });

    XucUser.getUserAsync().then(function (user) {
      $scope.user = user;
    });
    $scope.forwarded_title = "";
    $translate("FORWARDED").then(function (transl) {
      $scope.forwarded_title = transl;
    });
    $translate("FORWARD_LABEL").then(function (transl) {
      $scope.forwarded_label = transl;
    });
    $translate("INTERNAL_NUMBER").then(function (transl) {
      $scope.internal_nb_label = transl;
    });
    $translate("NO_ANSWER_ABREV").then(function (transl) {
      $scope.na_abrev = transl;
    });
    $translate("BUSY_ABREV").then(function (transl) {
      $scope.busy_abrev = transl;
    });

    var buildForwardLabel = function (user) {
      var fwdLabel = $scope.forwarded_label;
      if ($scope.user.naFwdEnabled) {
        fwdLabel += " " + $scope.na_abrev;
      }
      if ($scope.user.busyFwdEnabled) {
        fwdLabel += " " + $scope.busy_abrev;
      }
      return fwdLabel + " [" + forward.getDestination(user) + "]";
    };

    const lineNameMap = {
      [UserPreferencePreferredDevice.WebApp]: "xivo-webrtc",
      [UserPreferencePreferredDevice.MobileApp]: "xivo-mobile",
      [UserPreferencePreferredDevice.WebAppAndMobileApp]: "xivo-webrtc-mobile",
      [UserPreferencePreferredDevice.Phone]: "xivo-tel-fixe",
      [UserPreferencePreferredDevice.PhoneAndWebApp]: "xivo-tel-fixe-webrtc",
      [UserPreferencePreferredDevice.PhoneAndMobileApp]: "xivo-tel-fixe-mobile",
      [UserPreferencePreferredDevice.WebAppAndMobileAppAndPhone]:
        "xivo-tel-fixe-webrtc-mobile",
    };

    const getLineNameFromPreferredDevice = () => {
      const preferredDevice = UserPreferenceService.getPreferredDevice(CtiProxy.isUsingUa());
      let line = $scope.isWebRtcActive() ? "xivo-webrtc" : "xivo-tel-fixe";
      if (CtiProxy.isUsingMobileApp() || CtiProxy.isUsingUa()) {
        line = lineNameMap[preferredDevice] || "xivo-tel-fixe-webrtc";
      }

      if (
        $scope.connectedHIDDevice &&
        (preferredDevice === UserPreferencePreferredDevice.WebApp ||
         preferredDevice === UserPreferencePreferredDevice.WebAppAndMobileApp)
      ) {
        line += "-headset";
      }
      return line;
    };

    $scope.getLineNumber = function () {
      return $scope.displayNumber ? "[" + CtiProxy.getLineNumber() + "]" : "";
    };

    $scope.getNumberLabel = function () {
      if (!$scope.user.dndEnabled) {
        if ($scope.user.uncFwdEnabled)
          return (
            $scope.forwarded_title +
            " [" +
            forward.getDestination($scope.user) +
            "]"
          );
        if ($scope.user.naFwdEnabled || $scope.user.busyFwdEnabled) {
          return buildForwardLabel($scope.user);
        }
        return $scope.internal_nb_label + " " + $scope.getLineNumber();
      }
      return forward.getDestination($scope.user) + " " + $scope.getLineNumber();
    };

    $scope.isDnd = () => $scope.user.dndEnabled;
    $scope.isForwarded = () =>
      !$scope.user.dndEnabled && forward.isForwarded($scope.user);

    $scope.isWebRtcActive = function () {
      return CtiProxy.isUsingWebRtc();
    };

    $scope.getDisplayIcon = () => {
      if ($scope.user.dndEnabled) {
        return "xivo-do-not-disturb";
      } else return getLineNameFromPreferredDevice();
    };

    $scope.$on("userConfigUpdated", function () {
      $scope.user = XucUser.getUser();
    });

    $scope.showMenu = function () {
      $state.go("interface.menu");
    };

    $scope.$on('$destroy',() => {
      switchHandler();
    });
  }
}
